import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import {
  Ability,
  Advantage,
  arrAbilities,
  arrAdvantages,
  arrFeedbacks,
  arrStatistics,
  arrUsContacts,
  Feedback,
  Statist,
  Tariff,
  UsContact,
} from './home.component.interface';
import { ERROR_MESSAGES, NAME_PROJECT } from '../../enum/constants';
import { BinotelService } from '../../services/binotel.service';
import { AuthService } from '../../services/auth.service';
import { ITariff } from '../../modules/crm/payment/components/payment-old/payment-old.interface';
import { IError } from '../../interfaces';
import { TariffService } from '../../services/tariff.service';
import { NotificationService } from '../../services/notifications.service';
import { parseCurrency, scrollTo } from '../../helpers';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  // Imported types, constants and similar
  protected readonly arrFeedbacks: Feedback[] = arrFeedbacks;
  protected readonly arrAbilities: Ability[] = arrAbilities;
  protected readonly arrAdvantages: Advantage[] = arrAdvantages;
  protected readonly arrUsContacts: UsContact[] = arrUsContacts;
  protected readonly arrStatistics: Statist[] = arrStatistics;
  public tariffPackages: Tariff[] = [];

  // Variables for destroy
  private readonly destroy$ = new Subject<null>();

  // Other public variables
  protected readonly NAME_PROJECT = NAME_PROJECT;
  protected readonly currentYear = new Date().getFullYear();
  protected readonly parseCurrency = parseCurrency;
  protected readonly scrollTo = scrollTo;
  public isHeaderHidden: boolean = false;
  public lastScrollPosition: number = 0;

  constructor(
    private authService: AuthService,
    private tariffService: TariffService,
    private notificationService: NotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initUtm();
    this.tariffService.getTariffs().subscribe({
      next: (res) => {
        this.tariffPackages = res.map((t: ITariff) => {
          return {
            ...t,
            sales: t.sales_percent ? t.price - (t.price * t.sales_percent) / 100 : t.sales_price,
          };
        });
      },
      error: (res) => {
        (res.error?.errors || []).forEach((err: IError) => {
          this.notificationService.showError('', ERROR_MESSAGES[err.code]);
        });
      },
    });
  }

  private initUtm() {
    const utm_source = this.activatedRoute.snapshot.queryParams['utm_source'];
    if (utm_source) {
      this.router.navigate([], {
        queryParams: {
          utm_source: null,
        },
        queryParamsHandling: 'merge',
      });
      localStorage.setItem('utm_source', utm_source);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToRegister() {
    this.router.navigate(['/register']);
  }

  originalInstagramImage = '/assets/svgs/social/instagram_unactive.svg';
  hoverInstagramImage = '/assets/svgs/social/instagram_active.svg';

  originalFacebookImage = '/assets/svgs/social/facebook_unactive.svg';
  hoverFacebookImage = '/assets/svgs/social/facebook_active.svg';

  originalLinkedinImage = '/assets/svgs/social/linkedin_unactive.svg';
  hoverLinkedinImage = '/assets/svgs/social/linkedin_active.svg';

  changeImage(event: MouseEvent, url: string) {
    const imageElement = event.target as HTMLImageElement;
    imageElement.src = url;
  }

  restoreImage(event: MouseEvent, url: string) {
    const imageElement = event.target as HTMLImageElement;
    imageElement.src = url;
  }

  parseName(name: string, keys: any): string {
    return name.replace('{olx}', keys['olx']).replace('{tg}', keys['telegram']);
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(): void {
  //   const currentScrollPosition = window.pageYOffset;
  //   this.isHeaderHidden = currentScrollPosition > this.lastScrollPosition;
  //   this.lastScrollPosition = currentScrollPosition;
  // }
}
